import axios from 'axios';

// 개발/프로덕션 모두 상대 경로 사용 → 개발 서버 setupProxy가 /api/receipts 를 백엔드로 전달 (3000/3006 등 어떤 포트에서도 동일 동작)
const BASE_URL = '';

const receiptAxios = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// API 경로 상수
const API_PATHS = {
  RECEIPTS: '/api/receipts/',
  SEARCH: '/api/receipts/search'
};

export interface Receipt {
  _id?: string;  // MongoDB ID
  id: string;    // Keep the id field for backward compatibility
  eventId: string;
  churchId: {
    mainId: string;
    subId: string;
  };
  churchName: string;
  managerName: string;
  managerPhone: string;
  partTotal: number;
  partStudent: number;
  partTeacher: number;
  partYM: number;
  costs: number;
  paymentMethod: 'card' | 'bank' | 'cash';
  paymentStatus: 'pending' | 'completed' | 'cancelled';
  paymentDate: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ReceiptResponse {
  success: boolean;
  data: Receipt[];
  count: number;
  error?: string;
}

export interface BatchReceiptResponse {
  success: boolean;
  data: {
    created: number;
    failed: number;
    errors: Array<{ index: number; message: string }>;
  };
  message: string;
}

export const receiptApi = {
  createBatchReceipts: async (receipts: Omit<Receipt, 'id' | '_id' | 'createdAt' | 'updatedAt'>[]) => {
    try {
      const response = await receiptAxios.post<BatchReceiptResponse>(`${API_PATHS.RECEIPTS}batch`, { receipts });
      return response.data;
    } catch (error) {
      console.error('Error creating batch receipts:', error);
      throw error;
    }
  },

  createReceipt: async (data: Omit<Receipt, 'id' | 'createdAt' | 'updatedAt'>) => {
    try {
      const response = await receiptAxios.post<{ success: boolean; data: Receipt }>(API_PATHS.RECEIPTS, data);
      return response.data;
    } catch (error) {
      console.error('Error creating receipt:', error);
      throw error;
    }
  },

  getReceipts: async (params?: { eventId?: string; eventIds?: string[] | string; churchId?: string; page?: number; limit?: number }) => {
    try {
      const response = await receiptAxios.get<ReceiptResponse>(API_PATHS.RECEIPTS, { params });
      return response.data;
    } catch (error) {
      console.error('Error getting receipts:', error);
      throw error;
    }
  },

  getReceiptById: async (id: string) => {
    try {
      const response = await receiptAxios.get<{ success: boolean; data: Receipt }>(`${API_PATHS.RECEIPTS}${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting receipt:', error);
      throw error;
    }
  },

  updateReceipt: async (id: string, data: Partial<Omit<Receipt, 'id' | 'createdAt' | 'updatedAt'>>) => {
    try {
      const response = await receiptAxios.put<{ success: boolean; data: Receipt }>(`${API_PATHS.RECEIPTS}${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating receipt:', error);
      throw error;
    }
  },

  deleteReceipt: async (id: string) => {
    try {
      const response = await receiptAxios.delete<{ success: boolean }>(`${API_PATHS.RECEIPTS}${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting receipt:', error);
      throw error;
    }
  }
}; 